
<template>
  <div>
    <template v-if="isSuccess">
      <div :class="wrong ? 'bordeRojo' : ''" style="width: 100%; height:100%;">
        <img
          v-if="file.mime.startsWith('image')"
          :src="base64()"
          :class="imageFill ? 'image-fill' : 'image-img'"
          :title="file.nombre"
        />
        <template v-else>
          <v-row no-gutters justify="center">
            <v-icon style="font-size:50px;margin-top:5px;">mdi-paperclip</v-icon>
            <v-col
              cols="12"
              style="margin-left:5px;margin-right:5px;padding:5px;width:100%;text-align:center;"
              :title="file.nombre"
              class="file-preview-text"
            >
              {{ file.nombre }}
            </v-col>
          </v-row>
        </template>
      </div>
    </template>
    <template v-if="isSaving">
      <v-progress-circular indeterminate color="primary"/>
    </template>
    <template v-if="isFailed">
      <span
        style="margin-left:5px;margin-right:5px;padding:5px;font-size:14px;"
        :title="file.error"
        class="file-preview-text error--text"
      >
        <v-icon color="error" small class="mr-1">error</v-icon>{{ file.error }}
      </span>
    </template>
    <div class="image-remove" :title="isFailed ? file.error : file.nombre" v-if="interactable">
      <o-btn-icon-tooltip
        v-if="isSuccess && saveAction"
        color="white"
        btnClass="no-draggable image-guardar-button"
        icon="mdi-content-save"
        tooltip="Guardar"
        @click.stop="$emit('guardar')"
      />
      <v-btn
        v-if="isSuccess && file.mime.startsWith('image')"
        color="white"
        style="background-color: grey"
        icon
        class="no-draggable image-zoom-button"
        @click.stop="$emit('ampliar')"
      >
        <v-icon>zoom_in</v-icon>
      </v-btn>
      <v-btn
        v-if="deletable"
        rounded
        style="background-color: grey"
        color="white"
        icon
        class="no-draggable image-remove-button"
        @click.stop="$emit('remove')"
      >
        <v-icon>delete</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    file: {
      required: true
    },
    deletable: {
      type: Boolean,
      default: true
    },
    interactable: {
      type: Boolean,
      default: true
    },
    wrong: {
      type: Boolean,
      default: false
    },
    imageFill: {
      type: Boolean,
      default: false
    },
    saveAction: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    base64 () {
      let prefijo = 'data:' + this.file.mime + ';base64,'
      return prefijo + '' + this.file.documentoGrande
    }
  },
  computed: {
    isSaving: function () {
      return this.file.status === 'SAVING'
    },
    isSuccess: function () {
      return this.file.id || this.file.status === 'SUCCESS'
    },
    isFailed: function () {
      return this.file.status === 'FAILED'
    }
  },
  beforeDestroy () {}
}
</script>

<style>
.image-list-item .image-remove {
  z-index: 2;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  transition: opacity;
}
.image-list-item .image-remove:hover {
  opacity: 1;
}
.image-list-item.hide-remove .image-remove:hover,
.image-list-item.sortable-chosen .image-remove:hover {
  opacity: 0;
}
.image-list-item .image-remove .image-remove-button {
  position: absolute;
  top: 0;
  right: 0;
}
.image-list-item .image-remove .image-download-button,
.image-list-item .image-remove .image-zoom-button {
  position: absolute;
  top: 0;
  right: 40px;
}

.image-guardar-button {
  position: absolute;
  top: 0;
  right: 80px;
}

.image-list-item .image-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  max-width: 200px;
  max-height: 200px;
}
.image-list-item .image-fill {
  width: 100%;
  height: 100%;
  object-fit: fill;
}
.file-preview-text {
  height: 60px;
  max-height: 60px;
  line-height: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  word-wrap: break-word;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  align-self: baseline;
  word-break: break-all;
}

.bordeRojo {
  width: 100%;
  height: 100%;
  z-index: 1;
  outline: 1px solid red !important;
}
</style>
